import ChevronDownIcon from 'components/icons/ChevronDown';
import { FC } from 'react';
import styled from 'styled-components';

type Props = {
  open: boolean;
  active: boolean;
};
/* eslint-disable @typescript-eslint/no-unused-vars */
const RotatingChevronComponent: FC<Props> = ({ open, active, ...props }) => {
  return (
    <div {...props}>
      <ChevronDownIcon />
    </div>
  );
};

const RotatingChevron = styled(RotatingChevronComponent)`
  height: 100%;
  display: grid;
  place-items: center;
  position: relative;
  left: 0.5rem !important;
  right: 0rem;
  svg {
    stroke: ${({ active }) =>
      active ? 'var(--primary-400)' : 'var(--gray-400)'};
    transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: 0.2s;
  }
`;

export default RotatingChevron;
